import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').then((reg) => {
      console.log('Service worker registered, checking for updates...');
      
      // Function to check and show update
      const checkForUpdate = () => {
        if (reg.waiting) {
          console.log('✅ Update waiting to be activated!');
          window.dispatchEvent(new Event('sw-update-available'));
        }
      };
      
      // Check immediately
      console.log('Checking for updates immediately...');
      reg.update().then(() => {
        checkForUpdate();
      });
      
      // Check for updates every 5 seconds
      setInterval(() => {
        console.log('⏰ Polling for updates...');
        reg.update().then(() => {
          checkForUpdate();
        });
      }, 5000);

      // Listen for new service workers becoming available
      reg.addEventListener('updatefound', () => {
        console.log('📦 New service worker found!');
        const newWorker = reg.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('✅ New service worker ready to activate!');
            window.dispatchEvent(new Event('sw-update-available'));
          }
        });
      });

      // Also listen for controller change
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('🔄 Service worker controller changed');
      });
    }).catch((err) => {
      console.error('Service worker registration failed:', err);
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
